import { baseResources, baseResourceActions } from "routes/enum";

const { USER_MANAGEMENT_USERS, USER_MANAGEMENT_ROLES, WORKSPACE_PROFILE } =
    baseResources;

const { CREATE, UPDATE } = baseResourceActions;

/** Add new users (only user-management permission in seed) */
export const USER_CREATE_PERMISSION = [`${CREATE}_${USER_MANAGEMENT_USERS}`];

/** Create new custom role */
export const ROLES_CREATE_PERMISSION = [`${CREATE}_${USER_MANAGEMENT_ROLES}`];

/** Edit start-up profile */
export const WORKSPACE_PROFILE_UPDATE_PERMISSION = [
    `${UPDATE}_${WORKSPACE_PROFILE}`,
];

export const USER_ACCESS_ROLES_PERMISSION_MAP = {
    "Add new users": USER_CREATE_PERMISSION,
    "Create new custom role": ROLES_CREATE_PERMISSION,
    "Edit start-up profile": WORKSPACE_PROFILE_UPDATE_PERMISSION,
};
